export enum __COLORS {
  DARK_GREY = '#6F6F6E',
  LIGHT_GREY = '#BFBFBF',
  WHITE = '#FFFFFF',
  PRIMARY = '#f3cd6d'
}
